import React from "react";
import { Query } from "react-apollo";
import { string } from "prop-types";
import { Loading, Error } from "@components";
import SwitchTeam from "./SwitchTeam";
import { VIEWER_CAMPAIGNS_QUERY } from "./queries";

const SwitchTeamQuery = (props) => (
  <Query query={VIEWER_CAMPAIGNS_QUERY} variables={{}}>
    {({ data, loading }) => {
      if (loading) {
        return <Loading />;
      }
      if (data) {
        const {
          Viewer: {
            firstName,
            lastName,
            avatarImage,
            activeStatus,
            activeCampaign,
            personalAccount,
            runningCampaigns,
            endedCampaigns,
            endsOn,
          },
        } = data;
        return (
          <SwitchTeam
            activeCampaign={activeCampaign}
            activeStatus={activeStatus}
            campaignMembersUrl={props.campaignMembersUrl}
            editCampaignUrl={props.editCampaignUrl}
            endedCampaigns={endedCampaigns}
            endsOn={endsOn}
            firstName={firstName}
            joinCampaignUrl={props.joinCampaignUrl}
            lastName={lastName}
            newCampaignUrl={props.newCampaignUrl}
            personalAccount={personalAccount}
            personalUserUrl={props.personalUserUrl}
            photoImage={avatarImage}
            rootUrl={props.rootUrl}
            runningCampaigns={runningCampaigns}
            switchTeamUrl={props.switchTeamUrl}
            userFundsUrl={props.userFundsUrl}
          />
        );
      }
      return <Error msg="Unable to load teams." />;
    }}
  </Query>
);

export default SwitchTeamQuery;

SwitchTeamQuery.propTypes = {
  switchTeamUrl: string.isRequired,
  personalUserUrl: string.isRequired,
  editCampaignUrl: string.isRequired,
  userFundsUrl: string.isRequired,
  joinCampaignUrl: string.isRequired,
  newCampaignUrl: string.isRequired,
  campaignMembersUrl: string.isRequired,
  rootUrl: string.isRequired,
};
